import { render, staticRenderFns } from "./ReassignModal.vue?vue&type=template&id=2b2443e2&"
import script from "./ReassignModal.vue?vue&type=script&lang=js&"
export * from "./ReassignModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports